import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center w-full py-1"
};
import PlayerComponent from "@/modules/team/components/Player.vue";
import { Player } from "@/modules/team/entity";
import Talent from "@/modules/youth/components/Talent.vue";
import PlayerQueryPaginator from "@/modules/global-search/components/PlayerQueryPaginator.vue";
import GlobalSearchLayout from "@/modules/global-search/pages/GlobalSearchLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalPlayersIndexPage',
  setup(__props) {
    const query = ref(Player.createQueryBuilder('player').innerJoinAndSelect('player.country', 'country').leftJoinAndSelect('player.team', 'team'));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(GlobalSearchLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('search_players')), 1)]),
        default: _withCtx(() => [_createVNode(PlayerQueryPaginator, {
          query: query.value
        }, {
          player: _withCtx(({
            player
          }) => [_createElementVNode("div", _hoisted_1, [_createVNode(Talent, {
            talent: player.revealedTalent,
            class: "mr-1"
          }, null, 8, ["talent"]), _createVNode(PlayerComponent, {
            player: player,
            "hide-constitution": "",
            class: "grow"
          }, null, 8, ["player"]), _createElementVNode("div", null, _toDisplayString(_ctx.$money(player.marketValue)), 1)])]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});